module.exports = __webpack_public_path__ + "static/Hip-Hop-Caucus-VA-d7fac6466e1f09a6c5c7e3f203d7b14f.jpeg";